module.exports = __webpack_public_path__ + "static/media/gh.6ad2b9cb.svg";